// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistant-bubble-root {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: left;
}

.assistant-fab {
  width: 3.25rem;
  height: 3.25rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}

.assistant-panel {
  position: relative;
  width: 320px;
  max-width: calc(100vw - 3rem);
  max-height: calc(100vh - 7.5rem);
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.assistant-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.9rem;
  background: #eef1f6;
  color: #263041;
  font-weight: 600;
  font-size: 0.9rem;
}

.assistant-panel-minimized {
  max-height: none;
}

.assistant-panel-minimized .assistant-panel-header {
  cursor: pointer;
}

.assistant-header-buttons {
  display: flex;
  align-items: center;
}

.assistant-header-status {
  margin-left: 0.5rem;
  font-weight: 400;
  font-size: 0.75rem;
  color: #5b6b81;
}

.assistant-panel-body {
  padding: 0.75rem 0.9rem;
  overflow-y: auto;
  flex: 1 1;
}

.assistant-empty-state {
  font-size: 0.82rem;
  color: #6b7785;
}

.assistant-messages {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.assistant-message {
  font-size: 0.85rem;
  line-height: 1.4;
  padding: 0.5rem 0.65rem;
  border-radius: 8px;
  max-width: 90%;
  white-space: pre-wrap;
}

.assistant-message-user {
  align-self: flex-end;
  background: #5b6b81;
  color: #fff;
}

.assistant-message-assistant {
  align-self: flex-start;
  background: #f1f3f6;
  color: #263041;
  white-space: normal;
}

/* Markdown in assistant replies, kept compact for the small panel. */
.assistant-message-assistant > :first-child {
  margin-top: 0;
}

.assistant-message-assistant > :last-child {
  margin-bottom: 0;
}

.assistant-message-assistant p,
.assistant-message-assistant ul,
.assistant-message-assistant ol {
  margin: 0 0 0.5rem;
}

.assistant-message-assistant ul,
.assistant-message-assistant ol {
  padding-left: 1.2rem;
}

.assistant-message-assistant li + li {
  margin-top: 0.2rem;
}

.assistant-message-assistant h1,
.assistant-message-assistant h2,
.assistant-message-assistant h3,
.assistant-message-assistant h4 {
  margin: 0.5rem 0 0.35rem;
  font-size: 0.9rem;
}

.assistant-message-assistant code {
  background: #e3e7ed;
  padding: 0 0.25rem;
  border-radius: 4px;
  font-size: 0.8rem;
}

.assistant-message-assistant pre {
  overflow-x: auto;
  background: #e3e7ed;
  padding: 0.5rem;
  border-radius: 6px;
}

.assistant-message-assistant pre code {
  padding: 0;
}

.assistant-message-assistant table {
  border-collapse: collapse;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
}

.assistant-message-assistant th,
.assistant-message-assistant td {
  border: 1px solid #d5dbe3;
  padding: 0.2rem 0.4rem;
}

.assistant-panel-footer {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
  border-top: 1px solid #eee;
}

.assistant-model-note {
  padding: 0.35rem 0.9rem;
  border-bottom: 1px solid #eef1f6;
  font-size: 0.75rem;
  color: #6b7785;
}

/* Top-left corner grip for resizing the panel. */
.assistant-resize-handle {
  position: absolute;
  top: 0;
  left: 0;
  width: 14px;
  height: 14px;
  cursor: nwse-resize;
  z-index: 1;
  background: linear-gradient(135deg, #9aa5b4 0 2px, transparent 2px 5px, #9aa5b4 5px 7px, transparent 7px);
  border-top-left-radius: 10px;
  touch-action: none;
}
`, "",{"version":3,"sources":["webpack://./src/Assistant/AssistantBubble.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,yGAAyG;EACzG,4BAA4B;EAC5B,kBAAkB;AACpB","sourcesContent":[".assistant-bubble-root {\n  position: fixed;\n  right: 1.5rem;\n  bottom: 1.5rem;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: left;\n}\n\n.assistant-fab {\n  width: 3.25rem;\n  height: 3.25rem;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n}\n\n.assistant-panel {\n  position: relative;\n  width: 320px;\n  max-width: calc(100vw - 3rem);\n  max-height: calc(100vh - 7.5rem);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 10px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);\n  margin-bottom: 0.75rem;\n  overflow: hidden;\n}\n\n.assistant-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.6rem 0.9rem;\n  background: #eef1f6;\n  color: #263041;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.assistant-panel-minimized {\n  max-height: none;\n}\n\n.assistant-panel-minimized .assistant-panel-header {\n  cursor: pointer;\n}\n\n.assistant-header-buttons {\n  display: flex;\n  align-items: center;\n}\n\n.assistant-header-status {\n  margin-left: 0.5rem;\n  font-weight: 400;\n  font-size: 0.75rem;\n  color: #5b6b81;\n}\n\n.assistant-panel-body {\n  padding: 0.75rem 0.9rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.assistant-empty-state {\n  font-size: 0.82rem;\n  color: #6b7785;\n}\n\n.assistant-messages {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.assistant-message {\n  font-size: 0.85rem;\n  line-height: 1.4;\n  padding: 0.5rem 0.65rem;\n  border-radius: 8px;\n  max-width: 90%;\n  white-space: pre-wrap;\n}\n\n.assistant-message-user {\n  align-self: flex-end;\n  background: #5b6b81;\n  color: #fff;\n}\n\n.assistant-message-assistant {\n  align-self: flex-start;\n  background: #f1f3f6;\n  color: #263041;\n  white-space: normal;\n}\n\n/* Markdown in assistant replies, kept compact for the small panel. */\n.assistant-message-assistant > :first-child {\n  margin-top: 0;\n}\n\n.assistant-message-assistant > :last-child {\n  margin-bottom: 0;\n}\n\n.assistant-message-assistant p,\n.assistant-message-assistant ul,\n.assistant-message-assistant ol {\n  margin: 0 0 0.5rem;\n}\n\n.assistant-message-assistant ul,\n.assistant-message-assistant ol {\n  padding-left: 1.2rem;\n}\n\n.assistant-message-assistant li + li {\n  margin-top: 0.2rem;\n}\n\n.assistant-message-assistant h1,\n.assistant-message-assistant h2,\n.assistant-message-assistant h3,\n.assistant-message-assistant h4 {\n  margin: 0.5rem 0 0.35rem;\n  font-size: 0.9rem;\n}\n\n.assistant-message-assistant code {\n  background: #e3e7ed;\n  padding: 0 0.25rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n}\n\n.assistant-message-assistant pre {\n  overflow-x: auto;\n  background: #e3e7ed;\n  padding: 0.5rem;\n  border-radius: 6px;\n}\n\n.assistant-message-assistant pre code {\n  padding: 0;\n}\n\n.assistant-message-assistant table {\n  border-collapse: collapse;\n  font-size: 0.8rem;\n  margin-bottom: 0.5rem;\n}\n\n.assistant-message-assistant th,\n.assistant-message-assistant td {\n  border: 1px solid #d5dbe3;\n  padding: 0.2rem 0.4rem;\n}\n\n.assistant-panel-footer {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n  padding: 0.6rem 0.75rem;\n  border-top: 1px solid #eee;\n}\n\n.assistant-model-note {\n  padding: 0.35rem 0.9rem;\n  border-bottom: 1px solid #eef1f6;\n  font-size: 0.75rem;\n  color: #6b7785;\n}\n\n/* Top-left corner grip for resizing the panel. */\n.assistant-resize-handle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 14px;\n  height: 14px;\n  cursor: nwse-resize;\n  z-index: 1;\n  background: linear-gradient(135deg, #9aa5b4 0 2px, transparent 2px 5px, #9aa5b4 5px 7px, transparent 7px);\n  border-top-left-radius: 10px;\n  touch-action: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
